import { post } from "./index";

export const loginApi = (data: ILoginParams) => {
  const request: Irequest = {
    subUrl: `/admin/login`,
    data,
  };
  return post(request);
};